export var instance;
export var Telemetry = {
    instance: instance
};
